var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 54,
    viewBox: "0 0 71 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8968_327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.7926 24.1018L46.6985 1.20882C44.0951 -1.37434 39.6412 0.457274 39.6412 4.10701V20.2496H7.15108C3.44096 20.2496 0 23.2693 0 27C0 30.7307 3.44071 33.7504 7.15083 33.7504H39.6367V49.893C39.6367 53.5427 44.0906 55.3743 46.694 52.7912L69.7881 29.8982C71.4012 28.2961 71.4057 25.7039 69.7926 24.1018Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8968_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowShow);
export default __webpack_public_path__ + "static/media/right-arrow-show.b91d8def5291ae08e97480cc7b78dc2a.svg";
export { ForwardRef as ReactComponent };